import React, { useState, useEffect } from 'react';
import { employeeAPI } from '../services/api';
import AddEmployeeDialog from './AddEmployeeDialog';
import BulkUploadEmployeeDialog from './BulkUploadEmployeeDialog';

const EmployeeManagement = () => {
  const [employees, setEmployees] = useState([]);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(true);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [bulkUploadDialogOpen, setBulkUploadDialogOpen] = useState(false);

  useEffect(() => {
    loadEmployees();
  }, []);

  const loadEmployees = async () => {
    try {
      setLoading(true);
      const response = await employeeAPI.getAll();
      setEmployees(response.data);
    } catch (error) {
      setMessage({
        type: 'error',
        text: 'Failed to load employees'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (employeeId) => {
    if (window.confirm('Are you sure you want to delete this employee?')) {
      try {
        await employeeAPI.delete(employeeId);
        setMessage({ type: 'success', text: 'Employee deleted successfully!' });
        loadEmployees();
      } catch (error) {
        setMessage({
          type: 'error',
          text: error.response?.data?.error || 'Failed to delete employee'
        });
      }
    }
  };

  const handleAddSuccess = () => {
    loadEmployees();
  };

  if (loading) {
    return (
      <div className="card">
        <p>Loading employees...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem', gap: '0.75rem' }}>
          <button 
            className="btn btn-secondary" 
            onClick={() => setBulkUploadDialogOpen(true)}
            style={{ padding: '0.5rem 1.5rem' }}
          >
            📤 Bulk Upload Employees
          </button>
          <button 
            className="btn btn-primary" 
            onClick={() => setAddDialogOpen(true)}
            style={{ padding: '0.5rem 1.5rem' }}
          >
            + Add Employee
          </button>
        </div>
        
        {message.text && (
          <div className={`alert alert-${message.type}`} style={{ marginBottom: '1rem' }}>
            {message.text}
          </div>
        )}
        
        {employees.length === 0 ? (
          <p>No employees registered yet.</p>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Department</th>
                  <th>Delivery Unit</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {employees.map(employee => (
                  <tr key={employee.id}>
                    <td>{employee.name}</td>
                    <td>{employee.email}</td>
                    <td>{employee.department || '-'}</td>
                    <td>{employee.deliveryUnit || '-'}</td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(employee.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <AddEmployeeDialog
        isOpen={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
        onSave={handleAddSuccess}
      />

      <BulkUploadEmployeeDialog
        isOpen={bulkUploadDialogOpen}
        onClose={() => setBulkUploadDialogOpen(false)}
        onSave={handleAddSuccess}
      />
    </div>
  );
};

export default EmployeeManagement;
